import React from 'react';
import { Sparkles } from 'lucide-react';
import { releases } from '../../data/releaseNotes';

const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
};

const WhatsNewPage: React.FC = () => {
  return (
    <div className="p-4 sm:p-6 overflow-auto h-full">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-6 sm:mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-amber-100 dark:bg-amber-900/30 rounded-lg flex items-center justify-center">
              <Sparkles className="w-6 h-6 text-amber-600 dark:text-amber-400" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-warm-white">
              What's New
            </h1>
          </div>
          <p className="text-gray-600 dark:text-gray-400">
            The latest features, improvements, and updates to Agent Commander.
          </p>
        </div>

        {/* Release cards */}
        <div className="space-y-6">
          {releases.map((release, index) => (
            <div
              key={release.version}
              className={`bg-white dark:bg-cap-dark p-6 rounded-lg border shadow-sm ${
                index === 0
                  ? 'border-primary-300 dark:border-primary-700'
                  : 'border-gray-200 dark:border-gray-700'
              }`}
            >
              {/* Version + date row */}
              <div className="flex items-center gap-3 mb-2">
                <span className="px-2.5 py-0.5 text-sm font-semibold bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 rounded-full">
                  {release.version}
                </span>
                {index === 0 && (
                  <span className="px-2 py-0.5 text-xs font-medium bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 rounded-full">
                    Latest
                  </span>
                )}
                <span className="text-sm text-gray-500 dark:text-gray-400">
                  {formatDate(release.date)}
                </span>
              </div>

              {/* Headline */}
              <h2 className="text-xl font-bold text-gray-900 dark:text-warm-white mb-3">
                {release.headline}
              </h2>

              {/* Highlights */}
              <ul className="space-y-2">
                {release.highlights.map((highlight, hIndex) => (
                  <li key={hIndex} className="flex items-start gap-2 text-gray-700 dark:text-gray-300">
                    <span className="flex-shrink-0" role="img" aria-hidden="true">{highlight.emoji}</span>
                    <span>{highlight.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatsNewPage;
